import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface UIState {
  isLoading: boolean
  notifications: Array<{
    id: string
    type: 'info' | 'success' | 'warning' | 'error'
    title: string
    message: string
    read: boolean
    createdAt: string
  }>
  modals: {
    [key: string]: boolean
  }
}

const initialState: UIState = {
  isLoading: false,
  notifications: [],
  modals: {}
}

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    addNotification: (state, action: PayloadAction<Omit<UIState['notifications'][0], 'id' | 'createdAt'>>) => {
      const notification = {
        ...action.payload,
        id: Date.now().toString(),
        createdAt: new Date().toISOString()
      }
      state.notifications.push(notification)
    },
    removeNotification: (state, action: PayloadAction<string>) => {
      state.notifications = state.notifications.filter(n => n.id !== action.payload)
    },
    markNotificationAsRead: (state, action: PayloadAction<string>) => {
      const notification = state.notifications.find(n => n.id === action.payload)
      if (notification) {
        notification.read = true
      }
    },
    clearNotifications: (state) => {
      state.notifications = []
    },
    openModal: (state, action: PayloadAction<string>) => {
      state.modals[action.payload] = true
    },
    closeModal: (state, action: PayloadAction<string>) => {
      state.modals[action.payload] = false
    },
    closeAllModals: (state) => {
      state.modals = {}
    }
  }
})

export const {
  setLoading,
  addNotification,
  removeNotification,
  markNotificationAsRead,
  clearNotifications,
  openModal,
  closeModal,
  closeAllModals
} = uiSlice.actions

export default uiSlice.reducer 